export const videos: any = {
    us: {
        pc: 'https://websiteoss.ecoflow.com/upload/video/1735633368781/SmartInsights-1.mp4',
        posterPC: 'https://websiteoss.ecoflow.com/upload/image/1735788893348/smart_insight.jpg',
        posterH5: 'https://websiteoss.ecoflow.com/upload/image/1735789040206/smart_insight_M.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/video/1735633379708/SmartInsights-1-h5.mp4',
    },
    ca: {
        pc: 'https://websiteoss.ecoflow.com/upload/video/1735633368781/SmartInsights-1.mp4',
        posterPC: 'https://websiteoss.ecoflow.com/upload/image/1735788893348/smart_insight.jpg',
        posterH5: 'https://websiteoss.ecoflow.com/upload/image/1735789040206/smart_insight_M.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/video/1735633379708/SmartInsights-1-h5.mp4',
    },
    eu: {
        pc: 'https://websiteoss.ecoflow.com/upload/video/1744264254591/%E5%BC%80%E5%8F%91-AI-%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU-%E6%AC%A7%E5%85%83.mp4',
        posterPC: 'https://websiteoss.ecoflow.com/upload/image/1744343545978/AI-EU-PC.jpg',
        posterH5: 'https://websiteoss.ecoflow.com/upload/image/1744343546294/phone_AI-EU.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/video/1744257182389/%E5%BC%80%E5%8F%91_phone_AI_%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU-%E6%AC%A7%E5%85%83.mp4',
    },
    uk: {
        pc: 'https://websiteoss.ecoflow.com/upload/video/1744265151459/%E5%BC%80%E5%8F%91-AI-%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU-%E8%8B%B1%E9%95%91.mp4',
        posterPC:
            'https://websiteoss.ecoflow.com/upload/image/1744343710229/%E5%BC%80%E5%8F%91-AI-%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU-%E8%8B%B1%E9%95%91.jpg',
        posterH5:
            'https://websiteoss.ecoflow.com/upload/image/1744343709891/%E5%BC%80%E5%8F%91_phone_AI_%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU-%E8%8B%B1%E9%95%91.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/video/1744265151208/%E5%BC%80%E5%8F%91_phone_AI_%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU-%E8%8B%B1%E9%95%91.mp4',
    },
    fr: {
        pc: 'https://websiteoss.ecoflow.com/upload/video/1744265055501/%E5%BC%80%E5%8F%91-AI-%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU.mp4',
        posterPC: 'https://websiteoss.ecoflow.com/upload/image/1744343687146/%E5%BC%80%E5%8F%91-AI-%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU0.jpg',
        posterH5: 'https://websiteoss.ecoflow.com/upload/image/1744343665463/%E5%BC%80%E5%8F%91_phone_AI_%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU0.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/video/1744265055284/%E5%BC%80%E5%8F%91_phone_AI_%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU.mp4',
    },
    de: {
        pc: 'https://websiteoss.ecoflow.com/upload/video/1744265120006/%E5%BC%80%E5%8F%91-AI-%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU.mp4',
        posterPC: 'https://websiteoss.ecoflow.com/upload/image/1744343495331/%E5%BC%80%E5%8F%91-AI-%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU.jpg',
        posterH5: 'https://websiteoss.ecoflow.com/upload/image/1744343495245/%E5%BC%80%E5%8F%91_phone_AI_%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/video/1744265119806/%E5%BC%80%E5%8F%91_phone_AI_%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU.mp4',
    },
    // 以下素材暂未提供，先用eu的
    it: {
        pc: 'https://websiteoss.ecoflow.com/upload/video/1744264254591/%E5%BC%80%E5%8F%91-AI-%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU-%E6%AC%A7%E5%85%83.mp4',
        posterPC: 'https://websiteoss.ecoflow.com/upload/image/1744343545978/AI-EU-PC.jpg',
        posterH5: 'https://websiteoss.ecoflow.com/upload/image/1744343546294/phone_AI-EU.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/video/1744257182389/%E5%BC%80%E5%8F%91_phone_AI_%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU-%E6%AC%A7%E5%85%83.mp4',
    },
    es: {
        pc: 'https://websiteoss.ecoflow.com/upload/video/1744264254591/%E5%BC%80%E5%8F%91-AI-%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU-%E6%AC%A7%E5%85%83.mp4',
        posterPC: 'https://websiteoss.ecoflow.com/upload/image/1744343545978/AI-EU-PC.jpg',
        posterH5: 'https://websiteoss.ecoflow.com/upload/image/1744343546294/phone_AI-EU.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/video/1744257182389/%E5%BC%80%E5%8F%91_phone_AI_%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU-%E6%AC%A7%E5%85%83.mp4',
    },
};
export const imgItems: any = {
    us: [
        [
            'https://websiteoss.ecoflow.com/upload/image/1746175703409/electricity-us-1.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1746175703409/electricity-us-1.jpg',
        ],
        ['https://websiteoss.ecoflow.com/upload/image/1746175712067/save-us-1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1746175712067/save-us-1.jpg'],
        [
            'https://websiteoss.ecoflow.com/upload/image/1735615439049/SmartInsights4.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1735615439596/SmartInsights4-h5.jpg',
        ],
        [
            'https://websiteoss.ecoflow.com/upload/image/1735615528124/SmartInsights5.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1735615439948/SmartInsights5-h5.jpg',
        ],
        [
            // us将video 替换成图片，所以这个是排1
            'https://websiteoss.ecoflow.com/upload/image/1746177936224/energy-us-2.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1746177936224/energy-us-2.jpg',
        ],
    ],
    ca: [
        [
            'https://websiteoss.ecoflow.com/upload/image/1746175703409/electricity-us-1.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1746175703409/electricity-us-1.jpg',
        ],
        ['https://websiteoss.ecoflow.com/upload/image/1746175712067/save-us-1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1746175712067/save-us-1.jpg'],
        [
            'https://websiteoss.ecoflow.com/upload/image/1735615439049/SmartInsights4.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1735615439596/SmartInsights4-h5.jpg',
        ],
        [
            'https://websiteoss.ecoflow.com/upload/image/1735615528124/SmartInsights5.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1735615439948/SmartInsights5-h5.jpg',
        ],
        [
            // us将video 替换成图片，所以这个是排1
            'https://websiteoss.ecoflow.com/upload/image/1746177936224/energy-us-2.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1746177936224/energy-us-2.jpg',
        ],
    ],
    eu: [
        [
            'https://websiteoss.ecoflow.com/upload/image/1744459319657/%E7%94%B5%E4%BB%B7%E5%A5%97%E9%A4%90.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459456780/Frame%201612690133.png',
        ],
        [
            'https://websiteoss.ecoflow.com/upload/image/1744459319969/%E8%8A%82%E7%9C%81%E7%94%B5%E8%B4%B9.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459456989/Frame%201612690134.png',
        ],
        [
            'https://websiteoss.ecoflow.com/upload/image/1744459320278/Frame%201612690129.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459456395/Frame%201612690131.png',
        ],
        [
            'https://websiteoss.ecoflow.com/upload/image/1744459320539/Frame%201612690130.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459456582/Frame%201612690132.png',
        ],
    ],
    uk: [
        [
            'https://websiteoss.ecoflow.com/upload/image/1744459515949/%E7%94%B5%E4%BB%B7%E5%A5%97%E9%A4%90.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459566461/Frame%201612690153.png',
        ],
        [
            'https://websiteoss.ecoflow.com/upload/image/1744459516126/%E8%8A%82%E7%9C%81%E7%94%B5%E8%B4%B9.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459566653/Frame%201612690154.png',
        ],
        ['https://websiteoss.ecoflow.com/upload/image/1744618093425/pc.png', 'https://websiteoss.ecoflow.com/upload/image/1744618093271/m.png'],
        [
            'https://websiteoss.ecoflow.com/upload/image/1744459516549/Frame%201612690149.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459566271/Frame%201612690147.png',
        ],
    ],

    de: [
        ['https://websiteoss.ecoflow.com/upload/image/1744617791306/PC.png', 'https://websiteoss.ecoflow.com/upload/image/1744617791120/M.png'],
        [
            'https://websiteoss.ecoflow.com/upload/image/1744618353559/%E8%8A%82%E7%9C%81%E7%94%B5%E8%B4%B9-PC.png',
            'https://websiteoss.ecoflow.com/upload/image/1744618353320/%E8%8A%82%E7%9C%81%E7%94%B5%E8%B4%B9-M.png',
        ],
        ['https://websiteoss.ecoflow.com/upload/image/1744619894167/PC.png', 'https://websiteoss.ecoflow.com/upload/image/1744619893923/M.png'],
        [
            'https://websiteoss.ecoflow.com/upload/image/1744359030813/Frame%201612690050.png',
            'https://websiteoss.ecoflow.com/upload/image/1744359096824/Frame%201612690006.png',
        ],
    ],
    fr: [
        [
            'https://websiteoss.ecoflow.com/upload/image/1744364579053/%E7%94%B5%E4%BB%B7%E5%A5%97%E9%A4%90.png',
            'https://websiteoss.ecoflow.com/upload/image/1744364650109/Frame%201612690117.png',
        ],
        [
            'https://websiteoss.ecoflow.com/upload/image/1744618440500/%E8%8A%82%E7%9C%81%E7%94%B5%E8%B4%B9-PC.png',
            'https://websiteoss.ecoflow.com/upload/image/1744618440767/%E8%8A%82%E7%9C%81%E7%94%B5%E8%B4%B9-M.png',
        ],
        [
            'https://websiteoss.ecoflow.com/upload/image/1744364579402/Frame%201612690106.png',
            'https://websiteoss.ecoflow.com/upload/image/1744364649736/Frame%201612690104.png',
        ],
        [
            'https://websiteoss.ecoflow.com/upload/image/1744364579595/Frame%201612690107.png',
            'https://websiteoss.ecoflow.com/upload/image/1744364650288/Frame%201612690105.png',
        ],
    ],
    it: [
        [
            'https://websiteoss.ecoflow.com/upload/image/1744459319657/%E7%94%B5%E4%BB%B7%E5%A5%97%E9%A4%90.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459456780/Frame%201612690133.png',
        ],
        [
            'https://websiteoss.ecoflow.com/upload/image/1744459319969/%E8%8A%82%E7%9C%81%E7%94%B5%E8%B4%B9.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459456989/Frame%201612690134.png',
        ],
        [
            'https://websiteoss.ecoflow.com/upload/image/1744459320278/Frame%201612690129.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459456395/Frame%201612690131.png',
        ],
        [
            'https://websiteoss.ecoflow.com/upload/image/1744459320539/Frame%201612690130.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459456582/Frame%201612690132.png',
        ],
    ],
    es: [
        [
            'https://websiteoss.ecoflow.com/upload/image/1744459319657/%E7%94%B5%E4%BB%B7%E5%A5%97%E9%A4%90.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459456780/Frame%201612690133.png',
        ],
        [
            'https://websiteoss.ecoflow.com/upload/image/1744459319969/%E8%8A%82%E7%9C%81%E7%94%B5%E8%B4%B9.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459456989/Frame%201612690134.png',
        ],
        [
            'https://websiteoss.ecoflow.com/upload/image/1744459320278/Frame%201612690129.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459456395/Frame%201612690131.png',
        ],
        [
            'https://websiteoss.ecoflow.com/upload/image/1744459320539/Frame%201612690130.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459456582/Frame%201612690132.png',
        ],
    ],
};
//us和eu的power2确定
export const langConfig: any = {
    us: {
        power1: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745222957520/%E5%8F%91%E7%94%B5%E9%A2%84%E6%B5%8B.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745475549142/Frame%201612690291%20(2).png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745462008871/%E5%A4%A9%E6%B0%94%E9%A2%84%E6%B5%8B.png',
        },
        power2: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1746513614962/Frame%2016126902211.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1746513614962/Frame%2016126902211.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1746513614962/Frame%2016126902211.jpg',
        },
    },
    eu: {
        power1: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745652317342/%E5%A4%A9%E6%B0%94%E9%A2%84%E6%B5%8B%20(1).png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745652317342/%E5%A4%A9%E6%B0%94%E9%A2%84%E6%B5%8B%20(1).png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745652722319/%E5%A4%A9%E6%B0%94%E9%A2%84%E6%B5%8B%20(2).png',
        },
        power2: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745652317515/%E6%99%BA%E8%83%BD%E6%8E%A8%E8%8D%90%20(2).png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745652317515/%E6%99%BA%E8%83%BD%E6%8E%A8%E8%8D%90%20(2).png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745652722144/%E6%99%BA%E8%83%BD%E6%8E%A8%E8%8D%90%20(3).png',
        },
    },
    de: {
        power1: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745476875567/%E5%A4%A9%E6%B0%94%E9%A2%84%E6%B5%8B_de.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745476875567/%E5%A4%A9%E6%B0%94%E9%A2%84%E6%B5%8B_de.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745476875400/%E5%A4%A9%E6%B0%94%E9%A2%84%E6%B5%8B_de%20(1).png',
        },
        power2: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745393481568/Frame%201612690291%20(1).png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745393481568/Frame%201612690291%20(1).png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745462025939/%E6%99%BA%E8%83%BD%E6%8E%A8%E8%8D%90%20(1).png',
        },
    },
    fr: {
        power1: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745476991915/%E5%A4%A9%E6%B0%94%E9%A2%84%E6%B5%8B_fr.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745476991915/%E5%A4%A9%E6%B0%94%E9%A2%84%E6%B5%8B_fr.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745476992124/%E5%A4%A9%E6%B0%94%E9%A2%84%E6%B5%8B_fr%20(1).png',
        },
        power2: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745393481568/Frame%201612690291%20(1).png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745475549323/Frame%201612690291%20(3).png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745652722144/%E6%99%BA%E8%83%BD%E6%8E%A8%E8%8D%90%20(3).png',
        },
    },
    it: {
        power1: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745477191151/%E5%A4%A9%E6%B0%94%E9%A2%84%E6%B5%8B_it.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745477191151/%E5%A4%A9%E6%B0%94%E9%A2%84%E6%B5%8B_it.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745477314878/%E5%A4%A9%E6%B0%94%E9%A2%84%E6%B5%8B_it%20(1).png',
        },
        power2: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745393481568/Frame%201612690291%20(1).png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745475549323/Frame%201612690291%20(3).png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745652722144/%E6%99%BA%E8%83%BD%E6%8E%A8%E8%8D%90%20(3).png',
        },
    },
    es: {
        power1: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745477191550/%E5%A4%A9%E6%B0%94%E9%A2%84%E6%B5%8B_es.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745477191550/%E5%A4%A9%E6%B0%94%E9%A2%84%E6%B5%8B_es.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745477190524/%E5%A4%A9%E6%B0%94%E9%A2%84%E6%B5%8B_es%20(1).png',
        },
        power2: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745393481568/Frame%201612690291%20(1).png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745475549323/Frame%201612690291%20(3).png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745652722144/%E6%99%BA%E8%83%BD%E6%8E%A8%E8%8D%90%20(3).png',
        },
    },
    uk: {
        power1: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745477190730/%E5%A4%A9%E6%B0%94%E9%A2%84%E6%B5%8B_uk.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745477190730/%E5%A4%A9%E6%B0%94%E9%A2%84%E6%B5%8B_uk.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745477190970/%E5%A4%A9%E6%B0%94%E9%A2%84%E6%B5%8B_uk%20(1).png',
        },
        power2: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745393481568/Frame%201612690291%20(1).png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745475549323/Frame%201612690291%20(3).png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745652722144/%E6%99%BA%E8%83%BD%E6%8E%A8%E8%8D%90%20(3).png',
        },
    },
};
